"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.justifyContentTokens = exports.spaceTokens = exports.spaces = exports.scrollbarStyles = exports.visuallyHiddenStyles = exports.backgroundLayerStyles = exports.layerContainerStyles = exports.disabledStyles = exports.focusRingStyles = exports.interactiveElement = exports.resetStyles = void 0;
const lit_1 = require("lit");
const reset_css_raw_1 = __importDefault(require("@/stylesheets/shared/reset.css?raw"));
exports.resetStyles = (0, lit_1.css) `
  ${(0, lit_1.unsafeCSS)(reset_css_raw_1.default)}

  :host {
    box-sizing: border-box;
    font: inherit;
    color: inherit;
  }

  /* reset.css의 문서 본문용 목록 들여쓰기·간격은 컴포넌트 안에서 되돌린다.
     인라인된 reset.css 뒤에 와야 하고, 선택자 명시도를 맞춘다. */
  ul,
  ol,
  menu,
  fieldset,
  legend {
    margin: 0;
    padding: 0;
  }

  ul li:not(:first-child) {
    margin: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font: inherit;
  }

  input,
  textarea {
    padding: 0;
    border: none;
    background: none;
    font: inherit;
    color: inherit;
  }

  input:is([type='text'], [type='search'], [type='password'], [type='date'], [type='number']),
  textarea {
    -webkit-appearance: none;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  input::-webkit-inner-spin-button,
  input::-webkit-outer-spin-button {
    display: none;
    -webkit-appearance: none;
  }

  input::-webkit-search-decoration,
  input::-webkit-search-cancel-button,
  input::-webkit-search-results-button,
  input::-webkit-search-results-decoration {
    display: none;
  }
`;
/**
 * 컴포넌트가 shadow root 안에 렌더하는 상호작용 요소.
 * hover·focus·disabled 상태 선택자는 컴포넌트마다 태그를 다시 적지 않고 이 선택자로 잡는다.
 * 구조 규칙은 그대로 태그·class로 두고, 상태만 여기에 모은다.
 */
exports.interactiveElement = (0, lit_1.unsafeCSS)(":is(button, a, [role='button'], [role^='menuitem'], [role='option'], [role='checkbox'], [role='radio'], [role='switch'])");
/** 공유 focus 링 선언. --interaction-focus-outline 토큰을 소비하는 선택자 안에 펼쳐 쓴다. */
exports.focusRingStyles = (0, lit_1.css) `
  outline: var(--interaction-focus-outline);
  outline-offset: 2px;
`;
/**
 * 공유 비활성 선언. 비활성 상태를 다루는 선택자 안에 펼쳐 쓴다.
 * 눌림을 막으려 pointer-events를 끄는 행은 이 선언 뒤에 그것만 덧붙인다.
 */
exports.disabledStyles = (0, lit_1.css) `
  opacity: var(--opacity-50);
  cursor: not-allowed;
`;
/**
 * 뒤에 깔리는 ::before 레이어를 품는 요소의 선언. 레이어를 품을 선택자 안에 펼쳐 쓴다.
 * z-index: -1 레이어가 조상 배경 뒤로 빠지지 않도록 요소에서 쌓임 맥락을 만든다.
 */
exports.layerContainerStyles = (0, lit_1.css) `
  position: relative;
  isolation: isolate;
`;
/**
 * 요소 뒤를 채우는 ::before 레이어 선언. 채울 선택자의 선언 맨 뒤에 펼쳐 쓴다.
 * hover 배경은 레이아웃 박스를 밀지 않도록, 재질(배경+blur)은 조상 backdrop-filter가
 * 자손의 blur를 죽이지 않도록 요소 대신 이 레이어가 소유한다.
 */
exports.backgroundLayerStyles = (0, lit_1.css) `
  content: '';
  position: absolute;
  inset: 0;
  z-index: -1;
`;
/**
 * 화면에서만 감추고 접근성 트리에는 남기는 선언. 감출 요소의 선택자 안에 펼쳐 쓴다.
 * display·visibility로 감추면 스크린리더에서도 사라지므로 클립으로 밀어낸다.
 */
exports.visuallyHiddenStyles = (0, lit_1.css) `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
exports.scrollbarStyles = (0, lit_1.css) `
  &::-webkit-scrollbar {
    width: 0.5rem;
    height: 0.5rem;
    padding: 0.125rem;
    opacity: 0;
  }
  &::-webkit-scrollbar-track {
    background: inherit;
  }
  &::-webkit-scrollbar-thumb {
    margin: 0.125rem;
    background: var(--background-subtle-color);
    border-radius: var(--radius);
  }
  &::-webkit-scrollbar-button {
    display: none;
    background-color: inherit;
  }
  &::-webkit-scrollbar-corner {
    background-color: inherit;
  }

  &:hover::-webkit-scrollbar-thumb {
    background: var(--background-strong-color);
  }
`;
/**
 * 레이아웃 컴포넌트의 gap prop이 고르는 space 단계.
 * 0은 calc() 안에서도 식이 무효가 되지 않도록 길이로 둔다.
 */
exports.spaces = {
    '0': '0px',
    '1': 'var(--space-1)',
    '2': 'var(--space-2)',
    '3': 'var(--space-3)',
    '4': 'var(--space-4)',
    '6': 'var(--space-6)',
    '8': 'var(--space-8)',
    '12': 'var(--space-12)',
    '16': 'var(--space-16)',
    section: 'var(--space-section)',
};
/** 단계마다 컴포넌트가 소비하는 gap 토큰 하나에 값을 할당한다. `buildAttributeRules('gap', ...)`로 펼친다. */
const spaceTokens = (customProperty) => {
    const entries = Object.entries(exports.spaces).map(([space, value]) => [
        space,
        { [customProperty]: value },
    ]);
    return Object.fromEntries(entries);
};
exports.spaceTokens = spaceTokens;
exports.justifyContentTokens = {
    center: { 'justify-content': 'center' },
    'flex-end': { 'justify-content': 'flex-end' },
    'space-between': { 'justify-content': 'space-between' },
    'space-around': { 'justify-content': 'space-around' },
};
//# sourceMappingURL=data:application/json;base64,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